import React from "react";
import "./Footer.css";
import ApplicationForm from "../images/ApplicationForm.pdf";

const Footer = () => {
  return (
    <div className="container">
      <div className="footer">
        <div>
          <h2>NAVIGATION</h2>
          <ul>
            <li>
              <a href="#">Home</a>
            </li>
            <li>
              <a href="#our-courses">Courses</a>
            </li>
            <li>
              <a href="#instructor">Instrucote</a>
            </li>
            <li>
              <a href="#contactus">Contact Us</a>
            </li>
            <li className="application-form">
              <a href="https://docs.google.com/forms/d/e/1FAIpQLSdde1RPeGuya6eg4HDVhfsUG5ul9BmbJB9nQUhBJu3dA9v72g/viewform">
                Online Form Fill Up
              </a>
            </li>
            <li className="application-form">
              <a href={ApplicationForm} download={"Application Form"}>
                Download Application Form
              </a>
            </li>
          </ul>
        </div>
        <div>
          <h2>OUR COURSES</h2>
          <ul>
            <li>
              <a href="#our-courses">CITA</a>
            </li>
            <li>
              <a href="#our-courses">DITA</a>
            </li>
            <li>
              <a href="#our-courses">CCDA</a>
            </li>
            <li>
              <a href="#our-courses">CFAS</a>
            </li>
            <li>
              <a href="#our-courses">CDTP</a>
            </li>
            <li>
              <a href="#our-courses">CWD</a>
            </li>
          </ul>
        </div>
        <div>
          <h2>GET IN TOUCH </h2>
          <ul>
            <li style={{ lineHeight: "1.5rem", color: "rgb(160, 158, 158)" }}>
              Banshiroysole, Jatra Bishnupur,Salboni, Paschim Medinipur, 721147
              <p>Near Khasla Indumoti High School</p>
            </li>
            <li>
              <a href="tel:+917908955387">+91 7908955387</a>
            </li>
            <li>
              <a href="mailto:gyctc2023@gmail.com">gyctc2023@gmail.com</a>
            </li>
          </ul>
        </div>
        <div>
          <h2>FIND US ON MAP</h2>

          <iframe
            src="https://www.google.com/maps/embed?pb=!1m13!1m8!1m3!1d390.0819098264749!2d87.256248!3d22.672037!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zMjLCsDQwJzE5LjQiTiA4N8KwMTUnMjIuNCJF!5e1!3m2!1sen!2sus!4v1694796569390!5m2!1sen!2sus"
            width="250"
            height="130"
            allowfullscreen=""
            loading="lazy"
          ></iframe>
          <section className="social-media">
            <a
              href="https://www.facebook.com/profile.php?id=100093099949721&mibextid=ZbWKwL"
              target="_blank"
            >
              <i class="fa-brands fa-facebook fa-beat-fade"></i>
            </a>
            <a
              href="https://instagram.com/gyctc_2023?utm_source=qr&igshid=MzNlNGNkZWQ4Mg=="
              target="_blank"
            >
              <i className="fa-brands fa-instagram fa-beat-fade"></i>
            </a>
            <a
              href="https://api.whatsapp.com/send/?phone=7908955387&text&type=phone_number&app_absent=0"
              target="_blank"
            >
              <i className="fa-brands fa-whatsapp fa-beat-fade"></i>
            </a>
            <a href="mailto:gyctc2023@gmail.com" target="_blank">
              <i className="fa-solid fa-envelope fa-beat-fade"></i>
            </a>
          </section>
        </div>
      </div>

      <div className="footer-again">
        <span>
          © Copyright 2023 Gita Yuba Computer Training Centre | All Rights
          Reserved.
        </span>
        <span>Created by Saikat & Subhajit</span>
      </div>
    </div>
  );
};

export default Footer;
